import styled, { css } from 'styled-components'

type ToolbarButtonUiProps = {
  active?: boolean
  marginLeft?: string
  closeButton?: boolean
}

export const ToolbarButtonUi = styled.button<ToolbarButtonUiProps>`
  margin: 2px;
  padding: 5px 8px;
  background-color: transparent;
  position: relative;
  font-family: var(--font-family);
  color: rgba(107, 114, 128, 1);
  font-size: 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  height: 32px;
  width: 32px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${p =>
    p.marginLeft &&
    css`
      margin-left: ${p.marginLeft};
    `};
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
  &:first-of-type {
    border-top-left-radius: 5px;
  }
  ${props =>
    props.active &&
    css`
      background: rgba(243, 244, 246, 1);

      &:after {
        height: 3px;
      }
    `}
`
